import React from "react";
import PropTypes from "prop-types";
import { Input/*, NumericTextBox*/ } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { isEmpty, queryStringBuilder/*, convertDatestampToObject, getLocaleDateString*/ } from "../helpers";
import { Dialog/*, DialogActionsBar*/ } from "@progress/kendo-react-dialogs";
//import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import PartDemandPage from './PartDemandPage';
import isPage from "../hoc/isPage";
//import { AppContext } from '../context/AppContext';
import FormSection from '../components/FormSection';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import {
    GridColumn as Column/*,
    GridToolbar,
    GridDetailRow,*/
} from "@progress/kendo-react-grid";
import { BlankCell, IconButtonCell, BooleanCell } from "../components/utils/GridHelpers";
import GridContainer/*, { GridContainerToolbar, GridContainerToolbarOption }*/ from '../components/GridContainer';

class SearchPartPage extends React.Component {
    static propTypes = {
        orgID: PropTypes.number,
        orgVendorID: PropTypes.string,
        vendorID: PropTypes.number,
        partNumber: PropTypes.string,
        suggestedPOID: PropTypes.number
    }

    //container = null;
    gridHeader = null;
    gridPager = null;

    state = {
        parts: null,
        searchParams: {
            selectedPartNumber: ""
        },

        sort: [
            {
                field: "partNumber",
                dir: "asc"
            }
        ],
        skip: 0,
        pageSize: 10,

        hasParts: false,

        showDetailsDialog: false,
        selectedPart: null
    };

    handleSearch = e => {
        // get the items selected from the search filters control
        e.preventDefault();

        let builder = new queryStringBuilder();

        const searchParams = this.state.searchParams;

        // check if all required parts have been entered
        if (isEmpty(searchParams.selectedPartNumber)) {
            this.props.alert(
                "error",
                this.props.returnLocalizedString("m0023"),
                this.props.returnLocalizedString("m0292")
            );
            return;
        }

        // run the api search for the parts using these search parameters

        //let queryString = "";
        if (searchParams.selectedPartNumber) {
            builder.append("partNumber", searchParams.selectedPartNumber.trimEnd());
        }
        const orgID = this.props.orgID;
        if (orgID > 0)
            builder.append("orgID", orgID);
        builder.append("orgVendorID", this.props.orgVendorID);
        builder.append("suggestedPOID", this.props.suggestedPOID);

        // filter the data
        this.props
            .getData(
                `/api/portal/part/Search${builder.queryString}`
            )
            .then(response => {
                this.setState({
                    parts: response.data.map((lineItem, index) => Object.assign({
                        selected: false, // the Boolean field which indicates whether the item have be selected
                        index,
                    }, lineItem)),
                    hasParts: response.data.length > 0
                });
            })
            .catch(error => {

                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0294")
                );
            });
    };

    handleSearchParamsChange = e => {
        this.setState({
            searchParams: {
                ...this.state.searchParams,
                [e.target.name]: e.target.value
            }
        });
    };

    handleAddParts = () => {
        const selectedparts = this.state.parts.filter(p => p.selected);

        if (selectedparts.length <= 0) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0382"))
            return;
        }

        this.props.handleCloseModal(this, selectedparts);
    }

    //handleItemChange = (e) => {
    //    //console.log('handleItemChange')
    //    e.dataItem[e.field] = e.value;

    //    const index = e.dataItem['index'];

    //    this.setState({
    //        parts: Object.assign([], this.state.parts, { [index]: e.dataItem })
    //    });
    //}

    handleSelectedChange = (dataItem) => {
        const selected = !dataItem['selected'];

        // flip around
        dataItem['selected'] = selected;

        const index = dataItem['index'];

        this.setState({
            parts: Object.assign([], this.state.parts, { [index]: dataItem })
        });
    }

    getSelectedPartsMessage = () => {
        if (this.state.parts) {
            const selectedparts = this.state.parts.filter(p => p.selected);

            if (selectedparts.length > 1)
                return this.props.returnLocalizedString("m0383", "",selectedparts.length);
            else if (selectedparts.length === 1)
                return this.props.returnLocalizedString("m0384", "",selectedparts.length);
            else
                return '';
        }
        else
            return '';
    }

    handleDetailsClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDetailsDialog: true,
            selectedPart: props.dataItem
        })
    }

    handleCloseDetailsModal = (e, props) => {

        this.setState({
            showDetailsDialog: false,
            selectedPart: null
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidMount() {
        //console.log("SearchPartPage componentDidMount");
        this.gridHeader = document.querySelector('.k-dialog .k-grid .k-grid-header');
        this.gridPager = document.querySelector('.k-dialog .k-grid .k-grid-pager');

        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    handleResize = () => {
        //console.log("SearchPartPage handleResize");

        if (this.gridHeader) {
            let gridContentHeight = window.innerHeight * 0.8 // maximum search part dialog height
                - 24 // search part padding top
                - 42 // search part title
                - 68 // search part search section
                - 56 // search part bottom
                - 24 // search part padding bottom
                - this.gridHeader.offsetHeight // search part grid header height
                - this.gridPager.offsetHeight // search part grid pager height
                - 20 // search part grid pager height may increase by 20
                - 2; // grid border
            //console.log("SearchPartPage handleResize window.innerHeight: ", window.innerHeight);
            //console.log("SearchPartPage handleResize this.gridHeader.offsetHeight: ", this.gridHeader.offsetHeight);
            //console.log("SearchPartPage handleResize this.gridPager.offsetHeight: ", this.gridPager.offsetHeight);
            //console.log("SearchPartPage handleResize gridContentHeight: ", gridContentHeight);
            //console.log("SearchPartPage handleResize this.state.pageSize: ", this.state.pageSize);
            let newPageSize = Math.floor(gridContentHeight / 40);
            newPageSize = newPageSize > 10 ? 10 : newPageSize;
            if (newPageSize !== this.state.pageSize && newPageSize <= 10) {
                this.setState({
                    pageSize: newPageSize
                });
                //this.forceUpdate();
            }
        }
    }

    //<div className="k-window-title k-dialog-title search-part">Select Part</div>
    //onItemChange = { this.handleItemChange }
    render() {
        //console.log("SearchPartPage render");
        const searchParams = this.state.searchParams;

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        // 646px is the perfect width with the current css styles
        let perfectPartDemandDialogWidth = 646;
        let partDemandDialogWidth = `${perfectPartDemandDialogWidth}px`;
        if (this.state.showDetailsDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartDemandDialogWidth)
                    partDemandDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        //console.log("SearchPartPage render this.state.pageSize", this.state.pageSize);
        //ref={(gridContainer) => this.container = gridContainer}

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0289@ Qty Sold !DEVNOTE! Column Label 
        //!DBTRANS! @m0287@ Qty Available !DEVNOTE! Column Label
        //!DBTRANS! @m0281@ Demand !DEVNOTE! Option label
        //!DBTRANS! @m0292@ You must specify a part number. !DEVNOTE! Action status reason
        //!DBTRANS! @m0294@ Unable to retrieve part data. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0382@ Please select part(s) to add. !DEVNOTE! Action status
        //!DBTRANS! @m0383@ %var1% parts selected !DEVNOTE! Dialog
        //!DBTRANS! @m0384@ %var1% part selected !DEVNOTE! Dialog
        //!DBTRANS! @m0021@ Apply !DEVNOTE! Option Label
        //!DBTRANS! @m0386@ Selected !DEVNOTE! Option Label
        //!DBTRANS! @m0387@ Add Selected Parts !DEVNOTE! Option Label
        //!DBTRANS! @m0545@ Select Part !DEVNOTE! 

        return (
            <div className="position-relative">
                <div className="grid">
                    <div className="grid-row">
                        <div className="grid-col m-col-12 d-col-12">
                            <FormSection heading={this.props.returnLocalizedString("m0545")}>
                                <form className="bottom-margin-20" style={{ 'position': 'relative' }} >
                                    <span className="k-form-field right-margin-20">
                                        <Input required={true} label={this.props.returnLocalizedString("m0191")} name="selectedPartNumber" type="text" onChange={this.handleSearchParamsChange} value={searchParams.selectedPartNumber} />
                                    </span>
                                    <span className="k-form-field" style={{ 'position': 'absolute', 'bottom': '0' }}>
                                        <Button primary={true} onClick={this.handleSearch}>{this.props.returnLocalizedString("m0021")}</Button>
                                    </span>
                                </form>
                                <div className="dropdown" >
                                    <GridContainer
                                        sortColumn="partNumber"
                                        data={this.state.parts}
                                        pageable={true}
                                        buttonCount={3}
                                        pageSize={10}
                                        pageSizes={[5, 10, 20]}
                                    >
                                        <Column
                                            field="selected"
                                            title={this.props.returnLocalizedString("m0386")}
                                            headerClassName="boolean"
                                            className="boolean"
                                            editable={true}
                                            width="80px"
                                            cell={props => (
                                                <BooleanCell mode="checkbox" editable={true} handleChange={(e) => { this.handleSelectedChange(props.dataItem) }} {...props} />
                                            )}
                                        />
                                        <Column
                                            field="partNumber"
                                            title={this.props.returnLocalizedString("m0191")}
                                            editable={false}
                                            width="120px"
                                        />
                                        <Column
                                            field="description"
                                            title={this.props.returnLocalizedString("m0258")}
                                            editable={false}
                                            width="200px"
                                        />
                                        <Column
                                            field="quantityAvailable"
                                            title={this.props.returnLocalizedString("m0287")}
                                            editable={false}
                                            width="100px"
                                            headerClassName="numeric"
                                            className="numeric"
                                        />
                                        <Column
                                            field="quantitySold"
                                            title={this.props.returnLocalizedString("m0289")}
                                            editable={false}
                                            width="100px"
                                            headerClassName="numeric"
                                            className="numeric"
                                        />
                                        <Column
                                            filterable={false}
                                            resizable={false}
                                            sortable={false}
                                            reorderable={false}
                                            editable={false}
                                            width="50px"
                                            cell={(props) => (
                                                <IconButtonCell handleClick={(e) => { this.handleDetailsClick(e, props) }} icon="Details" title={this.props.returnLocalizedString("m0281")} {...props} />
                                            )}
                                        />
                                        <Column
                                            excludeFromExport
                                            filterable={false}
                                            resizable={false}
                                            sortable={false}
                                            reorderable={false}
                                            editable={false}
                                            cell={(props) => (
                                                <BlankCell {...props} />
                                            )}
                                        />
                                    </GridContainer>
                                    {this.state.showDetailsDialog && (
                                        <Dialog
                                            className="demand"
                                            style={{ top: top }}
                                            width={partDemandDialogWidth}
                                            minWidth={320}
                                            closeIcon={false}
                                        >
                                            <PartDemandPage
                                                handleCloseModal={this.handleCloseDetailsModal}
                                                orgID={parseInt(this.props.orgID, 10)}
                                                orgVendorID={this.props.orgVendorID}
                                                partNumber={this.state.selectedPart.partNumber} />
                                        </Dialog>)
                                    }
                                </div>
                            </FormSection>
                            <Toolbar onEditScrtooltip={false} atBottom={true} >
                                <ToolbarOption onEditScrtooltip={false} type="cancel" handleClick={this.props.handleCloseModal} />
                                <ToolbarOption onEditScrtooltip={false} type="add2" tooltip="m0387" primary={true} disabled={!this.state.hasParts} handleClick={this.handleAddParts} />
                                <ToolbarOption onEditScrtooltip={false} type="message" tooltip={this.getSelectedPartsMessage()} />
                            </Toolbar>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default isPage(SearchPartPage);



// WEBPACK FOOTER //
// ./src/containers/SearchPartPage.js